/* r26 product page (validated mockup 25/10). Runs after rashu.js (deferred, same order), which owns the form,
   the variant lookup, the cart drawer, the gallery and the modals. This file only adds: CTA label, missed size
   state, sticky offset of the buy block, size dialog tabs and the « Trouver ma taille » assistant. */
(function () {
  "use strict";
  var R = window.RASHU || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var pf = $("[data-product-form]");
  if (!pf || !$(".pp2")) return;

  var variants = [];
  try { variants = JSON.parse($("[data-variants]").textContent); } catch (e) {}
  var idInput = $("input[name=id]", pf), cta = $("[data-pp-cta]", pf), sizeGroup = $("[data-pp-size]", pf);
  var t = R.t || {};
  function money(c) {
    var v = (c / 100).toFixed(2).replace(".", ",").replace(",00", "");
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €";
  }

  /* ---------- CTA label follows the picked variant ---------- */
  function current() { var id = idInput && +idInput.value; return id ? variants.filter(function (v) { return v.id === id; })[0] : null; }
  function paintCta() {
    if (!cta || cta.getAttribute("aria-busy") === "true") return;
    var anyAvail = variants.some(function (v) { return v.available; });
    if (!anyAvail) { cta.textContent = t.soldOut || "Épuisé"; cta.disabled = true; return; }
    var v = current();
    cta.textContent = v ? (t.add || "Ajouter au panier") + " · " + money(v.price) : "Choisir ma taille";
  }
  pf.addEventListener("click", function (e) {
    var b = e.target.closest("[data-opt-i]"); if (!b || b.disabled) return;
    if (sizeGroup && sizeGroup.contains(b)) sizeGroup.classList.remove("is-miss");
    setTimeout(function () { paintCta(); syncSleeve(); }, 0);
  });
  /* submit without a size: rashu.js writes the message, we mark the group */
  pf.addEventListener("submit", function () { if (!current() && sizeGroup) sizeGroup.classList.add("is-miss"); });
  var stAdd = $("[data-sticky-add]");
  if (stAdd) stAdd.addEventListener("click", function () { if (!current() && sizeGroup) sizeGroup.classList.add("is-miss"); });
  /* keep the label after rashu.js re-enables the button at the end of an add */
  if (cta && "MutationObserver" in window) new MutationObserver(function () { if (!cta.hasAttribute("aria-busy")) paintCta(); }).observe(cta, { attributes: true, attributeFilter: ["aria-busy"] });
  paintCta();

  /* ---------- sticky buy block: stays fully visible under the header ---------- */
  var buy = $("[data-pp-buy]"), mq = window.matchMedia("(min-width: 1000px)");
  function headerBottom() {
    var h = $(".shopify-section.section-header") || $(".hd"); if (!h) return 0;
    var st = getComputedStyle(h).position;
    if (st !== "sticky" && st !== "fixed") { var hd = $(".hd"); if (!hd || (getComputedStyle(hd).position !== "sticky" && getComputedStyle(hd).position !== "fixed")) return 0; h = hd; }
    return Math.max(0, h.getBoundingClientRect().height);
  }
  function placeBuy() {
    if (!buy || !mq.matches) return;
    var top = headerBottom() + 12, room = window.innerHeight - buy.offsetHeight - 8;
    buy.style.setProperty("--pp-top", Math.round(Math.min(top, room)) + "px");
  }
  placeBuy();
  window.addEventListener("resize", placeBuy);
  window.addEventListener("load", placeBuy);
  if ("ResizeObserver" in window && buy) new ResizeObserver(placeBuy).observe(buy);

  /* ---------- lower page tabs (Design / Matière / Taille / Livraison) ---------- */
  $$("[data-pp3-tabs]").forEach(function (tl) {
    var tabs = $$("[role=tab]", tl);
    function pick(b, focus) {
      tabs.forEach(function (x) {
        var on = x === b, pn = document.getElementById(x.getAttribute("aria-controls"));
        x.setAttribute("aria-selected", on ? "true" : "false");
        x.tabIndex = on ? 0 : -1;
        if (pn) pn.hidden = !on;
      });
      if (focus) b.focus();
    }
    tl.addEventListener("click", function (e) { var b = e.target.closest("[role=tab]"); if (b) pick(b, false); });
    tl.addEventListener("keydown", function (e) {
      var i = tabs.indexOf(document.activeElement); if (i < 0) return;
      var n = e.key === "ArrowRight" ? i + 1 : e.key === "ArrowLeft" ? i - 1 : e.key === "Home" ? 0 : e.key === "End" ? tabs.length - 1 : null;
      if (n === null) return;
      e.preventDefault();
      pick(tabs[(n + tabs.length) % tabs.length], true);
    });
  });

  /* ---------- « Lire la suite » on long free descriptions ---------- */
  $$("[data-pp3-more]").forEach(function (m) {
    var bd = $("[data-pp3-more-bd]", m), b = $("[data-pp3-more-b]", m);
    if (!bd || !b) return;
    m.classList.add("is-cut");
    if (bd.scrollHeight <= bd.clientHeight + 24) { m.classList.remove("is-cut"); return; }
    b.hidden = false;
    b.addEventListener("click", function () {
      var open = m.classList.toggle("is-cut") === false;
      b.setAttribute("aria-expanded", open ? "true" : "false");
      b.textContent = open ? "Réduire" : "Lire la suite";
    });
  });

  /* ---------- size dialog ---------- */
  var dlg = $("[data-pp-dlg]");
  if (!dlg) return;
  var tables = {};
  try { tables = JSON.parse($("[data-pp-sizes]", dlg).textContent); } catch (e) {}
  var key = dlg.getAttribute("data-key") || "mc", sleeveOpt = +dlg.getAttribute("data-sleeve-opt");
  var res = $("[data-pp-res]", dlg), apply = $("[data-pp-apply]", dlg), picked = null, use = "train";

  function tab(which) {
    var b = $("#pp2-tb-" + which, dlg); if (b) b.click();
  }
  /* a product with a 2-value Manches option follows the pressed sleeve */
  function syncSleeve() {
    if (sleeveOpt < 0) return;
    var on = $('[data-opt-i="' + sleeveOpt + '"][aria-pressed=true]', pf);
    var nk = on && /longue/i.test(on.getAttribute("data-value")) ? "ml" : "mc";
    if (nk !== key) { key = nk; calc(); }
  }
  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-pp-tab]");
    if (o) {
      var which = o.getAttribute("data-pp-tab");
      tab(which); calc();
      setTimeout(function () {
        var f = which === "calc" ? $("[data-pp-m=chest]", dlg) : $("#pp2-tb-tab", dlg);
        if (f) f.focus();
      }, 90);
    }
  });
  $("[data-pp-show-tab]", dlg).addEventListener("click", function () { tab("tab"); $("#pp2-tb-tab", dlg).focus(); });

  $$("[data-pp-use]", dlg).forEach(function (b) {
    b.addEventListener("click", function () {
      use = b.getAttribute("data-pp-use");
      $$("[data-pp-use]", dlg).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      calc();
    });
  });
  $$("[data-pp-m]", dlg).forEach(function (i) { i.addEventListener("input", calc); });

  var FIELDS = { chest: "poitrine", waist: "taille" };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function mark(size) {
    $$("tr.is-on", dlg).forEach(function (r) { r.classList.remove("is-on"); });
    if (!size) return;
    $$('[data-sz-table="' + key + '"] tbody tr', dlg).forEach(function (r) { if (r.firstElementChild.textContent.trim() === size) r.classList.add("is-on"); });
  }
  function calc() {
    var T = tables[key]; if (!T || !res) return;
    var m = {};
    $$("[data-pp-m]", dlg).forEach(function (i) { var v = parseFloat(String(i.value).replace(",", ".")); if (v > 0) m[i.getAttribute("data-pp-m")] = v; });
    picked = null;
    if (!m.chest || !m.waist) {
      res.innerHTML = '<div class="pp2-dlg__card pp2-dlg__empty">Entrez au moins votre tour de poitrine et votre tour de taille.</div>';
      apply.disabled = true; mark(null); return;
    }
    var idx = -1, by = "chest", out = false;
    ["chest", "waist"].forEach(function (f) {
      var col = T[f], i = -1;
      for (var k = 0; k < col.length; k++) { if (col[k] >= m[f]) { i = k; break; } }
      if (i === -1) { out = true; return; }
      if (i > idx) { idx = i; by = f; }
    });
    var top = T.sizes[T.sizes.length - 1];
    if (out) {
      res.innerHTML = '<div class="pp2-dlg__card"><span>Notre conseil</span><b class="na">Hors tableau</b><small>Vos mesures dépassent la plus grande taille (' + esc(top) + "). Écrivez-nous avant de commander.</small></div>";
      apply.disabled = true; mark(null); return;
    }
    var base = idx, note = "Calée sur votre tour de " + FIELDS[by] + " (" + m[by] + " cm, tableau " + T.sizes[base] + " : " + T[by][base] + " cm)";
    if (use === "train") {
      if (idx < T.sizes.length - 1) { idx++; note += ", puis 1 taille au-dessus pour l'entraînement"; }
      else note += ", déjà la plus grande taille";
    }
    if (key === "ml" || key === "w") note += ". Modèle qui taille petit";
    note += ".";
    picked = T.sizes[idx];
    var btn = sizeGroup && $('[data-opt-i][data-value="' + picked + '"]', sizeGroup);
    var avail = btn && !btn.disabled;
    res.innerHTML = '<div class="pp2-dlg__card"><span>Notre conseil' + (use === "train" ? ", entraînement" : ", compétition") + "</span><b>" + esc(picked) + "</b><small>" + esc(note) + (btn && !avail ? " Cette taille est épuisée." : "") + "</small></div>";
    apply.disabled = !avail;
    mark(T.sizes[base]);
  }
  apply.addEventListener("click", function () {
    if (!picked || !sizeGroup) return;
    var btn = $('[data-opt-i][data-value="' + picked + '"]', sizeGroup);
    if (!btn || btn.disabled) return;
    btn.click();
    var x = $("[data-close]", dlg); if (x) x.click();
    setTimeout(function () { btn.focus(); }, 80);
  });
  syncSleeve();
  calc();
})();
